import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import "./index.css";
import "./styles/pos.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { store } from "./store";
import { ThemeProvider } from "./context/ThemeContext";
import { SignalRProvider } from "./context/SignalRContext";
import { StoreProvider } from "./context/StoreContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider>
        <StoreProvider>
          <SignalRProvider>
            <App />
          </SignalRProvider>
        </StoreProvider>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>,
);

reportWebVitals();
